import {
  Briefcase, Building2, TrendingUp, Target, HeartHandshake, LineChart, DollarSign, Wallet,
  Rocket, Box, Cpu, Code2, Hammer, Wrench, Bug, Beaker,
  MessageSquare, Headphones, Megaphone, Mail, Phone, Bell, Mic, Radio,
  Palette, Camera, Film, Music, Brush, PenTool, Lightbulb, Sparkles,
  Truck, Package, Calendar, ClipboardList, FileText, Settings, Cog, Workflow,
  Users, GraduationCap, Shield, Heart, Flag, Globe, Star, Award,
  type LucideIcon,
} from 'lucide-react';

export type BadgeIconName =
  | 'Briefcase' | 'Building2' | 'TrendingUp' | 'Target' | 'HeartHandshake' | 'LineChart' | 'DollarSign' | 'Wallet'
  | 'Rocket' | 'Box' | 'Cpu' | 'Code2' | 'Hammer' | 'Wrench' | 'Bug' | 'Beaker'
  | 'MessageSquare' | 'Headphones' | 'Megaphone' | 'Mail' | 'Phone' | 'Bell' | 'Mic' | 'Radio'
  | 'Palette' | 'Camera' | 'Film' | 'Music' | 'Brush' | 'PenTool' | 'Lightbulb' | 'Sparkles'
  | 'Truck' | 'Package' | 'Calendar' | 'ClipboardList' | 'FileText' | 'Settings' | 'Cog' | 'Workflow'
  | 'Users' | 'GraduationCap' | 'Shield' | 'Heart' | 'Flag' | 'Globe' | 'Star' | 'Award';

export interface BadgeIconEntry {
  name: BadgeIconName;
  label: string;
  icon: LucideIcon;
}

export interface BadgeCategoryGroup {
  id: 'business' | 'product' | 'communication' | 'creative' | 'operations' | 'people';
  label: string;
  icons: BadgeIconEntry[];
}

export const BADGE_CATEGORIES: BadgeCategoryGroup[] = [
  {
    id: 'business',
    label: 'Business',
    icons: [
      { name: 'Briefcase',   label: 'Lavoro',       icon: Briefcase },
      { name: 'Building2',   label: 'Azienda',      icon: Building2 },
      { name: 'TrendingUp',  label: 'Crescita',     icon: TrendingUp },
      { name: 'Target',      label: 'Obiettivi',    icon: Target },
      { name: 'HeartHandshake', label: 'Partnership', icon: HeartHandshake },
      { name: 'LineChart',   label: 'Analytics',    icon: LineChart },
      { name: 'DollarSign',  label: 'Vendite',      icon: DollarSign },
      { name: 'Wallet',      label: 'Finance',      icon: Wallet },
    ],
  },
  {
    id: 'product',
    label: 'Prodotto & Tech',
    icons: [
      { name: 'Rocket',  label: 'Lancio',     icon: Rocket },
      { name: 'Box',     label: 'Prodotto',   icon: Box },
      { name: 'Cpu',     label: 'Hardware',   icon: Cpu },
      { name: 'Code2',   label: 'Dev',        icon: Code2 },
      { name: 'Hammer',  label: 'Build',      icon: Hammer },
      { name: 'Wrench',  label: 'Manutenz.',  icon: Wrench },
      { name: 'Bug',     label: 'QA / Bug',   icon: Bug },
      { name: 'Beaker',  label: 'R&D',        icon: Beaker },
    ],
  },
  {
    id: 'communication',
    label: 'Comunicazione',
    icons: [
      { name: 'MessageSquare', label: 'Chat',       icon: MessageSquare },
      { name: 'Headphones',    label: 'Supporto',   icon: Headphones },
      { name: 'Megaphone',     label: 'Marketing',  icon: Megaphone },
      { name: 'Mail',          label: 'Email',      icon: Mail },
      { name: 'Phone',         label: 'Call',       icon: Phone },
      { name: 'Bell',          label: 'Alert',      icon: Bell },
      { name: 'Mic',           label: 'Podcast',    icon: Mic },
      { name: 'Radio',         label: 'Broadcast',  icon: Radio },
    ],
  },
  {
    id: 'creative',
    label: 'Creative',
    icons: [
      { name: 'Palette',   label: 'Design',     icon: Palette },
      { name: 'Camera',    label: 'Foto',       icon: Camera },
      { name: 'Film',      label: 'Video',      icon: Film },
      { name: 'Music',     label: 'Musica',     icon: Music },
      { name: 'Brush',     label: 'Art',        icon: Brush },
      { name: 'PenTool',   label: 'Branding',   icon: PenTool },
      { name: 'Lightbulb', label: 'Idea',       icon: Lightbulb },
      { name: 'Sparkles',  label: 'AI',         icon: Sparkles },
    ],
  },
  {
    id: 'operations',
    label: 'Operations',
    icons: [
      { name: 'Truck',         label: 'Logistica',  icon: Truck },
      { name: 'Package',       label: 'Magazzino',  icon: Package },
      { name: 'Calendar',      label: 'Pianific.',  icon: Calendar },
      { name: 'ClipboardList', label: 'Checklist',  icon: ClipboardList },
      { name: 'FileText',      label: 'Documenti',  icon: FileText },
      { name: 'Settings',      label: 'Config.',    icon: Settings },
      { name: 'Cog',           label: 'Processi',   icon: Cog },
      { name: 'Workflow',      label: 'Workflow',   icon: Workflow },
    ],
  },
  {
    id: 'people',
    label: 'People & Misc',
    icons: [
      { name: 'Users',         label: 'Team',       icon: Users },
      { name: 'GraduationCap', label: 'Formazione', icon: GraduationCap },
      { name: 'Shield',        label: 'Security',   icon: Shield },
      { name: 'Heart',         label: 'Wellness',   icon: Heart },
      { name: 'Flag',          label: 'Milestone',  icon: Flag },
      { name: 'Globe',         label: 'International', icon: Globe },
      { name: 'Star',          label: 'Premium',    icon: Star },
      { name: 'Award',         label: 'Award',      icon: Award },
    ],
  },
];

const BADGE_INDEX: Record<string, BadgeIconEntry> = (() => {
  const idx: Record<string, BadgeIconEntry> = {};
  for (const g of BADGE_CATEGORIES) for (const e of g.icons) idx[e.name] = e;
  return idx;
})();

export function getBadgeIcon(name: string | null | undefined): LucideIcon | null {
  if (!name) return null;
  return BADGE_INDEX[name]?.icon ?? null;
}

export function getBadgeLabel(name: string | null | undefined): string | null {
  if (!name) return null;
  return BADGE_INDEX[name]?.label ?? null;
}

export function isValidBadgeIcon(name: string | null | undefined): name is BadgeIconName {
  return !!name && name in BADGE_INDEX;
}
